









import {Vue,Component} from "vue-property-decorator";
import SelectSection from "@/components/users/SelectSection.vue";

@Component({
    components:{
        SelectSection
    }
})
export default class UserResult extends Vue {

}
